module.exports = __webpack_public_path__ + "img/not-found.0007e80e.png";